import React, {useContext, useLayoutEffect, useState} from "react";
import {IStepQuiz} from "../../../interfaces/IStepQuiz";
import {alpha, makeStyles} from "@material-ui/core/styles";
import Colors from "../../../styles/colors";
import {
    CardActionArea,
    IconButton,
    OutlinedInputProps,
    Snackbar,
    styled,
    TextField,
    TextFieldProps
} from "@material-ui/core";
import {AppContext} from "../../../App";
import CloseIcon from "@material-ui/icons/Close";
import {AppService} from "../../../services/app.service";
import QuizHeader from "./QuizHeader";

const useStyles = makeStyles((theme) => ({
    inputSection: {
        display: 'flex',
        justifyContent: 'center',
        width: window.innerWidth,
        paddingTop: 24,
        paddingBottom: 24,
        backgroundColor: "red",
    },
    inputContainer: {
        width: '100%',
        maxWidth: 720,
    },
    actionArea: {
        paddingLeft: 24,
        paddingRight: 24,
    },
    filler: {
        height: 700,
    },
    buttonStep: {
        width: '100%',
        borderRadius: 2,
        backgroundColor: Colors.primary,
        opacity: 5,
        height: 56,
        color: "white",
        fontFamily: [
            'LotaGrotesque',
        ].join(','),
        fontWeight: "bold",
        textTransform: "none",
        letterSpacing: 0.25,
        fontSize: 18,
        fontStretch: "normal",
        textAlign: "center",
    },
    mainContainer: {
        width: '100%',
        overflowY: "scroll",
        height: window.innerHeight,
    }

}));

interface ITextInputDictionary {
    [key: string]: string
}

const PATextInput = styled((props: TextFieldProps) => (
    <TextField
        InputProps={{ disableUnderline: true } as Partial<OutlinedInputProps>}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiFormLabel-root': {
        width: "100%",
        height: 14,
        fontFamily: [
            'LotaGrotesque',
        ].join(','),
        fontSize: 10,
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 1,
        color: '#687888',
    },
    '& .MuiInputLabel-filled': {
        width: "100%",
        height: 14,
        fontFamily: [
            'LotaGrotesque',
        ].join(','),
        fontSize: 10,
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 1,
        color: Colors.dark

    },
    '& .MuiInputLabel-shrink': {
        width: "100%",
        height: 14,
        fontFamily: [
            'LotaGrotesque',
        ].join(','),
        fontSize: 18,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 1,
        color: Colors.dark
    },
    '& .MuiFilledInput-root': {
        width: "100%",
        fontFamily: [
            'LotaGrotesque',
        ].join(','),
        fontSize: 16,
        border: '1px solid #e2e2e1',
        overflow: 'hidden',
        borderRadius: 2,
        backgroundColor: Colors.white,
        color: Colors.lessDark,
        transition: theme.transitions.create([
            'border-color',
            'background-color',
            'box-shadow',
        ]),
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '&.Mui-focused': {
            backgroundColor: 'transparent',
            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
            borderColor: theme.palette.primary.main,
        },
    },
}));

function MultiTextInput(props: IStepQuiz) {
    const [open, setOpen] = useState<boolean>(false)
    const [alertMsg, setAlertMsg] = useState<string>("")
    const context = useContext(AppContext);
    const classes = useStyles();
    let questionConfig: any = props.questionConfig;
    let textInputs = [];

    //input Items for the Text Object itself
    let inputItems: any = Object.values(questionConfig)[0]
    let capturedInputs: ITextInputDictionary = {}

    const[textContent, setTextContent] = useState<ITextInputDictionary>({'input-0': ''})

    for(let i = 0; i < inputItems.length; i++){
        // console.log(textContent[`input-${i.toString()}`])
        let inputValue: string = "";
        let textInputId: string = `input-${i.toString()}`;
        if(textContent[textInputId] !== undefined || typeof(textContent[textInputId]) !== 'undefined'){
            inputValue = textContent[textInputId]
        } else {
            inputValue = '';
        }
        console.log(inputValue)
        textInputs.push(
            <div className={'response-input-group'}>
                <div className={'input-label'}>{inputItems[i]}</div>
                <PATextInput
                    key={textInputId}
                    className={'input-item'}
                    id={textInputId}
                    variant="outlined"
                    onChange={ e => captureInput(e.target.id.toString(), e.target.value.toString())}
                    value={(textContent[textInputId] !== undefined || typeof(textContent[textInputId]) !== 'undefined') ? inputValue = textContent[textInputId] : ''}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </div>
        );
    }

    function captureInput(inputId: string, content: string)
    {
        capturedInputs = textContent;
        capturedInputs[`${inputId}`] = content;
        setTextContent({...capturedInputs});
        console.log(textContent);
    }

    function handleAction() {
        let validationResult: any = contentIsValid();
        console.log("Validation result ", validationResult);
        if(validationResult !== true) {
            setAlertMsg(validationResult);
            setOpen(true);
        } else {
            console.log('saving response');
            saveResponse(Number(context.currentWeekNo),
                Number(context.currentTaskNo),
                Number(context.currentStepNo),
                JSON.stringify(capturedInputs));
            props.moveNext();
        }
    }

    function saveResponse(weekNo: number, taskNo: number, stepNo: number, response: any) {
        let appService = new AppService();
        let _ = appService.saveQuizResponse(response, props.id, `${weekNo}${taskNo}${stepNo}`);
        console.log(_)
    }


    function countNumberOfEntry(): number {
        let inputCount: number = 0;
        Object.entries(capturedInputs).forEach(
            ([key, value]) => {
                console.log(key, value);

                // we need to make sure white space doesn't count as content.
                let trimmed = value.trim();
                if(trimmed.length > 0)
                    inputCount++;
            }
        );
        return inputCount
    }

    function InputsAreEmpty(): Boolean {
        let entryCount: number = countNumberOfEntry();
        console.log("Entry Count ", entryCount, "Captured = ", capturedInputs);
        if(entryCount > 0) {
            return false;
        }
        else {
            return true
        }
    }

    // validates the contents of the multitext component
    function contentIsValid(): boolean | string {
        capturedInputs = textContent
        // General Rule
        if(InputsAreEmpty()) {
            return "Please fill all the text to proceed";
        }

        // Screen Specific
        if(`${context.currentWeekNo}${context.currentTaskNo}${context.currentStepNo}` === '459' && countNumberOfEntry() < 5) {
            return "You need to write at least 5 people.";
        }

        if(`${context.currentWeekNo}${context.currentTaskNo}${context.currentStepNo}` === '459') {

        }

        return true;

    }


    const handleClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };


    useLayoutEffect(()=> {
        async function getUserData(){
            let appService = new AppService();
            const existing_response = await appService.getQuizResponse(props.id);
            console.log('existing response', existing_response.data.payload.saved_response)

            if(Object.keys(existing_response.data.payload.saved_response).length > 0){
                let savedResponse = JSON.parse(existing_response.data.payload.saved_response);
                setTextContent(savedResponse);
            } else {
                setTextContent({});
            }
        }
        getUserData();
    }, [context.currentStepNo,props.id]);

    return(
        <>
            <div className={classes.mainContainer}>
                <QuizHeader question={props.prompt} customLabel={'QUIZ'}/>
                <div className={'multi-text-section'}>
                    <div className={classes.inputContainer}>
                        {textInputs}
                    </div>
                    <div className={'mt-quiz-action-area'}>
                        <CardActionArea className={'transcript-previous-button'} onClick={props.moveBack}>
                            Previous
                        </CardActionArea>
                        <CardActionArea className={'transcript-button'} onClick={handleAction}>
                            {/*{(props.buttonLabel) ? props.buttonLabel : "Next"}*/}
                            Next
                        </CardActionArea>
                    </div>
                </div>

            </div>

            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
                message={alertMsg}
                action={
                    <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            />
        </>
    )
}

export default MultiTextInput;